<section class="w-[34rem] max-w-[calc(100vw-2rem)] rounded-[1.75rem] border border-lGray700 bg-lGray900 p-4 shadow-soft-black">
  @for (notification of notifications; track notification.id) {
    <article class="group py-3" [class.pt-0]="$first" [class.border-t]="!$first" [class.border-lGray700]="!$first">
      <div class="flex items-start gap-3 rounded-xl px-4 py-3 cursor-pointer hover:bg-lGray850" [class.bg-lGray850]="notification.selected">
        <div class="min-w-0 flex-1">
          <p class="text-lWhite text-base leading-5 tracking-wide max-w-[26rem]">{{ notification.title }}</p>
          <p class="mt-1.5 text-lGray500 text-sm leading-none">{{ notification.time }}</p>
        </div>

        <div class="flex items-center gap-3 pt-1 shrink-0">
          <div class="flex items-center gap-2 opacity-0 pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto">
            <button type="button" class="text-lGray500 hover:text-lWhite transition-colors" aria-label="Marcar como lida">
              <l-icon class="!text-2xl">mail</l-icon>
            </button>
            <button type="button" class="text-lDanger hover:opacity-85 transition-opacity" aria-label="Excluir notificação">
              <l-icon class="!text-2xl">delete</l-icon>
            </button>
          </div>

          @if (notification.unread) {
            <span class="w-3 h-3 rounded-full bg-lPrimary block" aria-hidden="true"></span>
          }
        </div>
      </div>
    </article>
  }
</section>
